import moment from "moment";
import { useTranslation } from "react-i18next";

import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
/* import ClearAllIcon from "@mui/icons-material/ClearAll";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import DateRangeOutlinedIcon from "@mui/icons-material/DateRangeOutlined";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import AppsIcon from "@mui/icons-material/Apps"; */

import { GROUP_BY_TIME, GROUP_BY_SURVEY } from "./importTimeline";
import CalendarIcon from "../Components/CalendarIcon";

export default function useGroupOptions() {
  const { t } = useTranslation();
  return [
    {
      id: GROUP_BY_TIME,
      title: t("timeline.buttons.time"),
      icon: <ScheduleOutlinedIcon />,
    },
    {
      id: GROUP_BY_SURVEY,
      title: t("timeline.buttons.survey"),
      icon: <AssignmentOutlinedIcon />,
      groupBy: (item) => item.filterKey,
    },
  ];
}
